import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clearFilterLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.component-slot-content.issue-search-warning-clear-filter.clear-filter-link',
		defaultMessage: 'Clear {filterCount, plural, one {this filter} other {these filters}}',
		description: 'The link for clear filters in the issue search warning flag',
	},
});
